'use strict';

require('url-polyfill');
require('./util/polyfills');

window.moment = require('./util/dates').global;

require('picturefill')();

// Polyfill `toLocaleString` with a better version which allows
// adding locale support since Welsh is not supported by browsers.
const intl = require('intl');

require('intl/locale-data/jsonp/en-GB');
require('intl/locale-data/jsonp/en');
require('intl/locale-data/jsonp/cy-GB');
require('intl/locale-data/jsonp/cy');

Date.prototype.toLocaleString = intl.__localeSensitiveProtos.Date.toLocaleString;

var common = require('./bootstraps/common');
var widgets = require('./bootstraps/widgets');

common.init();
widgets.init();



// WEBPACK FOOTER //
// ./main.js